import BasicSelect from "components/BasicInputs/BasicSelect";

export interface CountProps {
  perPage: number;
  page: number;
  onChange?: ({ page, perPage }: { page: number; perPage: number }) => void;
  length?: number;
  rowCounts?: number[];
}
export default function Count(props: CountProps) {
  const { onChange, perPage, page, length } = props;
  const rowCounts = props.rowCounts || [5, 10, 15, 20, 30, 40, 50];
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 20,
        padding: "0px 10px",
      }}
    >
      <div>
        <BasicSelect
          defaultValue={perPage}
          btnStyle={{ minWidth: 90, minHeight: 36 }}
          onChange={(val) => onChange && onChange({ page, perPage: val })}
          options={rowCounts.map((x) => ({ label: `${x} ردیف`, value: x }))}
          noVirtual
        />
      </div>
      <div>
        {(page - 1) * perPage + 1} - {perPage * page}
      </div>
      <div>از {length}</div>
    </div>
  );
}
